export const msgbox = {
  bg: {
    color: '#151a20',
  },
  label: {
    color: '#898c90',
  },
  value: {
    color: '#cacaca',
  },
  block: {
    border: {
      color: '#1778FF',
    },
  },
  mining_on: {
    border: {
      color: '#4ECDBE',
    },
  },
  subtree: {
    border: {
      color: '#6148C4',
    },
  },
  ping: {
    border: {
      color: '#444',
    },
  },
  getminingcandidate: {
    border: {
      color: '#2778FF',
    },
  },
  node_status: {
    border: {
      color: '#FF9500',
    },
  },
  default: {
    border: {
      color: 'orange',
    },
  },
}
